export const MeetOurExpertsBg = (props: any) => {
    return (
        <svg {...props} width="235" height="280" viewBox="0 0 235 280" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 0.5H207.793L234.5 27.207V268C234.5 274.351 229.351 279.5 223 279.5H12C5.64873 279.5 0.5 274.351 0.5 268V12C0.500004 5.64873 5.64873 0.5 12 0.5Z" fill="white" stroke="#1F1F1F" />
        </svg>
    )
}

export const MeetOurExpertsCorner = (props: any) => {
    return (
        <svg {...props} width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25.793 26.5H12C5.64873 26.5 0.5 21.3513 0.5 15V1.20703L25.793 26.5Z" fill="#D9D9D9" stroke="#1F1F1F" />
        </svg>
    )
}